import APIService from '@/services/APIService.js';

export default {
  getById(id) {
    return APIService.apiCall().get(`/testesQtdMatServ/getById/${id}`);
  },
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/testesQtdMatServ/getAll/${includeExpiredRecords}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/testesQtdMatServ/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/testesQtdMatServ/executar/${id}`);
  },
  salvar(postData, id) {
    return APIService.apiCall().post(`/testesQtdMatServ/salvar/${id}`, JSON.stringify(postData));
  },
  duplicar(id) {
    return APIService.apiCall().get(`/testesQtdMatServ/duplicar/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/testesQtdMatServ/baixar/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
